import React, { useEffect, useState } from "react";
import MainLayout from "../layout/MainLayout";
import Header from "../components/Header";
import { checkNaN, formatCurrency, months } from "../utils/utils";
import { BiPencil } from "react-icons/bi";
import { useDispatch, useSelector } from "react-redux";
import { getDropouts, updateDropouts } from "../redux/reducers/dropOutSlice"; // Assuming updateDropouts action exists
import Loader from "../components/loader/loader";
import { fetchPrograms } from "../redux/reducers/programsSlice";
import UnPaidCheckout from "./UnPaidCheckout";

const DropOut = ({unPaid}) => {
  const dispatch = useDispatch();

  const { programs, loading, error } = useSelector(
    (state) => state.programs ?? []
  );
  const { userDetails } = useSelector((state) => state.auth);
  const [programsData, setProgramData] = useState(programs ?? []);

  const { userId } = userDetails;

  useEffect(() => {
    // Fetch dropouts data based on userId
    if (userId) {
      dispatch(fetchPrograms(userId));
      setTimeout(() => {
        dispatch(fetchPrograms(userId));
      }, 1000);
    }
  }, [dispatch, userId]);

  useEffect(() => {
    setProgramData(programs);
  }, [programs]);

  // Handler to update the values dynamically
  const handleInputChange = (programId, year, month, value) => {
    setProgramData((prevData) =>
      prevData.map((program) =>
        program._id === programId
          ? {
              ...program,
              studentsDrops: program.studentsDrops.map((dropout) =>
                dropout.year === year
                  ? {
                      ...dropout,
                      months: {
                        ...dropout.months,
                        [month]: value,
                      },
                    }
                  : dropout
              ),
            }
          : program
      )
    );
  };

  const handleUpdate = (programId) => {
    // Prepare the data to be sent for update
    const programToUpdate = programsData.find(
      (program) => program._id === programId
    );

    if (programToUpdate) {
      const updatedData = programToUpdate.studentsDrops.map((dropout) => ({
        year: dropout.year,
        months: dropout.months,
      }));

      // Assuming an action exists to update dropouts
      dispatch(updateDropouts({ id: programId, years: updatedData }));
      setTimeout(() => {
        dispatch(fetchPrograms(userId));
      }, 1000);
    }
  };

  return (
    <>
      <MainLayout>
        <Loader loading={loading} />
       {
        unPaid ?
        (
          <UnPaidCheckout/>
        )

        : (
          <>
          <Header
          title="Dropout Tracker"
          subTitle={`${programsData?.length ?? 0} Programs`}
          description="Manage your Dropouts here."
          className="text-base sm:text-lg md:text-xl"
        />

        <div className="w-full space-y-8">
          {programsData.map((program, idx) => (
            <div key={idx}>
              {/* Program Name */}
              <Header
                title={program.programName}
                btnOnlcick={() => {
                  handleUpdate(program?._id);
                }}
                buttonText={"Update"}
                className="text-base sm:text-lg md:text-xl"
              />

              {/* Program Table */}
              <div className="w-full overflow-auto">
                <table className="min-w-full bg-white border border-gray-200 text-xs sm:text-sm md:text-base">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-6 py-3 text-left text-xs sm:text-sm md:text-base font-bold text-gray-500 uppercase tracking-wider">
                        Year
                      </th>
                      {months.map((month, idx) => (
                        <th
                          key={idx}
                          className="px-6 py-3 text-left text-xs sm:text-sm md:text-base font-bold text-gray-500 uppercase tracking-wider"
                        >
                          {month}
                        </th>
                      ))}
                      <th className="px-6 py-3 text-left text-xs sm:text-sm md:text-base font-bold text-gray-500 uppercase tracking-wider">
                        Total
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {program?.studentsDrops.map((dropoutData, yearIdx) => (
                      <tr key={yearIdx}>
                        <td className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-base text-gray-900 border-b border-gray-200">
                          {dropoutData?.year}
                        </td>
                        {months.map((month, idx) => (
                          <td
                            key={idx}
                            className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-base text-gray-900 border-b border-gray-200"
                          >
                            <div className="flex flex-row items-center">
                              <input
                                type="number"
                                min={0}
                                defaultValue={parseInt(dropoutData.months[month]) || 0}
                                // value={parseInt(dropoutData.months[month]) || 0}
                                onChange={(e) =>
                                  handleInputChange(
                                    program._id,
                                    dropoutData.year,
                                    month,
                                    e.target.value
                                  )
                                }
                                className="border-2 border-gray-500 p-2 rounded-xl"
                              />
                              <BiPencil className="text-purple-500 text-lg ml-2" />
                            </div>
                          </td>
                        ))}
                        <td className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-base text-gray-900 border-b border-gray-200">
                          {Object.values(dropoutData?.months).reduce(
                            (total, value) => parseInt(total) + (parseInt(value) || 0),
                            0
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          ))}
        </div>
          </>
        )
       }
      </MainLayout>
    </>
  );
};

export default DropOut;
